// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {

    align-items:start;
}
.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
	color: var(--bs-nav-pills-link-active-color);
	background-color: #fff;
    border:#B3D6FF solid 3px
}
.negative-items thead td {
    
    padding: 1rem 2rem !important;
    border: solid transparent 0px;
}
.negative-items {
  width: 100%;
  border-collapse: inherit;
  table-layout: fixed;
  text-align: center;
  font: 13px Verdana;
  border-radius: 30px;
  border-spacing: 0px;
  background: white;
}

.negative-items thead td {
  border: none;
  padding: 20px;
  background: #F8F9FD;
  color: var(--bs-gray-400);
  border-left: none;
}

.negative-items thead tr {
background:white;
}

.negative-items thead tr:first-child td:first-child {
  border-radius: 20px 0 0 20px;
}

.negative-items thead tr:first-child td:last-child {
  border-radius: 0 20px 20px 0;
}

.negative-items tbody td {
  padding: 20px;
}
.negative-items tbody td .indicator {
    background-color: var(--additionalsucces---green);
    height: 6px;
    min-width: 6px;
    border-radius: 3px;
    position: relative;
  }`, "",{"version":3,"sources":["webpack://./src/pages/report-audit/ReportAuditNew.css"],"names":[],"mappings":"AAAA;;IAEI,iBAAiB;AACrB;AACA;CACC,4CAA4C;CAC5C,sBAAsB;IACnB;AACJ;AACA;;IAEI,6BAA6B;IAC7B,6BAA6B;AACjC;AACA;EACE,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;AACA,gBAAgB;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;AACA;IACI,iDAAiD;IACjD,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,kBAAkB;EACpB","sourcesContent":[".content {\n\n    align-items:start;\n}\n.nav-pills .nav-link.active, .nav-pills .show > .nav-link {\n\tcolor: var(--bs-nav-pills-link-active-color);\n\tbackground-color: #fff;\n    border:#B3D6FF solid 3px\n}\n.negative-items thead td {\n    \n    padding: 1rem 2rem !important;\n    border: solid transparent 0px;\n}\n.negative-items {\n  width: 100%;\n  border-collapse: inherit;\n  table-layout: fixed;\n  text-align: center;\n  font: 13px Verdana;\n  border-radius: 30px;\n  border-spacing: 0px;\n  background: white;\n}\n\n.negative-items thead td {\n  border: none;\n  padding: 20px;\n  background: #F8F9FD;\n  color: var(--bs-gray-400);\n  border-left: none;\n}\n\n.negative-items thead tr {\nbackground:white;\n}\n\n.negative-items thead tr:first-child td:first-child {\n  border-radius: 20px 0 0 20px;\n}\n\n.negative-items thead tr:first-child td:last-child {\n  border-radius: 0 20px 20px 0;\n}\n\n.negative-items tbody td {\n  padding: 20px;\n}\n.negative-items tbody td .indicator {\n    background-color: var(--additionalsucces---green);\n    height: 6px;\n    min-width: 6px;\n    border-radius: 3px;\n    position: relative;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
